<template>
  <component
    :is="MarketCard"
    :marketId="marketId"
    :marketIds="marketIds"
    :eventId="eventId"
  />
</template>

<script lang="ts">
import {
  defineComponent,
  computed,
  PropType,
  defineAsyncComponent,
  ComputedRef
} from "vue";
import { Market } from "@fresh8/types/src/betData";
import { injectBetData } from "@fresh8/ad-data-composition/src/betData";
import {
  MOBILE_LEADERBOARD,
  LMLB,
  useTemplateSize
} from "@fresh8/ad-data-composition/src/useTemplateSize";
import { CardTypes } from "@fresh8/types/src";

/**
 * Checks if market display a draw option
 */

function hasDrawOption(eventMarket: Market) {
  return eventMarket.options.length > 2;
}

function getCard(cardType: CardTypes, eventMarket: Market, isMobile: boolean) {
  if (cardType === "mainMarket" && isMobile) {
    return hasDrawOption(eventMarket) ? CardMap["wdw"] : CardMap["ww"];
  }

  return CardMap[cardType];
}

const CardMap = {
  promo: defineAsyncComponent(() =>
    import(`./markets/promo/WrapperSelector.vue`)
  ),
  mainMarket: defineAsyncComponent(() =>
    import(`./markets/multi-main/WrapperSelector.vue`)
  ),
  insight: defineAsyncComponent(() =>
    import(`./markets/insight/WrapperSelector.vue`)
  ),
  wdw: defineAsyncComponent(() =>
    import(`./markets/win-draw-win/WrapperSelector.vue`)
  ),
  ww: defineAsyncComponent(() =>
    import(`./markets/win-win/WrapperSelector.vue`)
  ),
  list: defineAsyncComponent(() =>
    import(`./markets/list/WrapperSelector.vue`)
  ),
  parlay: defineAsyncComponent(() =>
    import(`./markets/parlay/ParlayWrapper.vue`)
  ),
  h2h: defineAsyncComponent(() => import(`./markets/h2h/WrapperSelector.vue`)),
  offer: defineAsyncComponent(() => import(`./markets/offer/OfferWrapper.vue`))
};

export default defineComponent({
  name: "CardSelector",
  props: {
    marketIds: {
      type: Array as PropType<string[]>,
      required: true
    },
    cardType: { type: String as PropType<CardTypes>, required: true }
  },
  setup(props) {
    const betData = injectBetData();

    const { size } = useTemplateSize();

    const markets = computed(() => {
      return props.marketIds.map((id: string) => betData.markets.value[id]);
    }) as ComputedRef<Market[]>;

    const isMobile = computed(
      () =>
        size.value.name === MOBILE_LEADERBOARD.name ||
        size.value.name === LMLB.name
    );

    const MarketCard = computed(() => {
      return getCard(props.cardType, markets.value[0], isMobile.value);
    });

    return {
      MarketCard,
      marketId: computed(() => markets.value[0]?.marketId),
      eventId: computed(() => markets.value[0]?.eventId)
    };
  }
});
</script>
